var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnticlockwise(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 372,
    height: 372,
    viewBox: "0 0 372 372",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M369.609 191.338L369.761 185.516H371.052L370.901 191.382L369.609 191.338Z",
    fill: "#9E7E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.517 195.084L369.589 192.176L370.88 192.219L370.801 195.149L369.517 195.084Z",
    fill: "#9E7E00"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M369.365 197.082L369.437 196.107L370.722 196.18L370.65 197.161L369.365 197.082Z",
    fill: "#9E7E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.221 198.929L369.257 198.445L370.548 198.532L370.505 199.022L369.221 198.929Z",
    fill: "#9E7E00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M369.089 199.663L369.052 200.152L370.34 200.25L370.377 199.761L369.089 199.663Z",
    fill: "#9E7E00"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M369.025 201.497L369.062 201.014L370.346 201.122L370.31 201.613L369.025 201.497Z",
    fill: "#9E7E00"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M368.924 202.782L368.967 202.299L370.251 202.414L370.208 202.905L368.924 202.782Z",
    fill: "#9E7E00"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M368.622 205.827L368.687 205.336L369.964 205.473L369.906 205.964L368.622 205.827Z",
    fill: "#9E7E00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M368.252 209.142L368.19 209.629L369.472 209.792L369.534 209.305L368.252 209.142Z",
    fill: "#9E7E00"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M367.315 215.365L367.655 213.46L367.893 211.541L369.17 211.721L368.925 213.655L368.593 215.575L367.315 215.365Z",
    fill: "#9E7E00"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M366.428 220.33L366.947 217.451L368.217 217.675L367.698 220.575L366.428 220.33Z",
    fill: "#9E7E00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M365.793 223.606L366.002 222.704L366.168 221.795L367.431 222.047L367.265 222.964L367.056 223.873L365.793 223.606Z",
    fill: "#9E7E00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M365.114 226.564L365.316 225.662L366.579 225.944L366.37 226.853L365.114 226.564Z",
    fill: "#9E7E00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M364.617 228.699L364.826 227.797L366.082 228.093L365.873 229.002L364.617 228.699Z",
    fill: "#9E7E00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M364.271 230.208L364.408 229.609L365.663 229.92L365.526 230.519L364.271 230.208Z",
    fill: "#9E7E00"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M363.838 231.998C363.888 231.803 363.953 231.608 363.997 231.406L365.245 231.724C365.202 231.926 365.137 232.121 365.086 232.315L363.838 231.991V231.998Z",
    fill: "#9E7E00"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M363.333 233.766L363.499 233.182L364.747 233.514L364.581 234.105L363.333 233.766Z",
    fill: "#9E7E00"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M362.828 235.539L362.994 234.947L364.242 235.294L364.069 235.885L362.828 235.539Z",
    fill: "#9E7E00"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M362.33 237.307L362.496 236.723L363.73 237.076L363.564 237.675L362.33 237.307Z",
    fill: "#9E7E00"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M361.823 239.082L361.989 238.49L363.223 238.865L363.057 239.457L361.823 239.082Z",
    fill: "#9E7E00"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M360.8 242.3L360.901 242.012L362.127 242.409L362.026 242.697L360.8 242.3Z",
    fill: "#9E7E00"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M360.108 244.526L360.009 244.82L361.232 245.234L361.332 244.94L360.108 244.526Z",
    fill: "#9E7E00"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M359.141 247.214L359.234 246.926L360.454 247.351L360.353 247.647L359.141 247.214Z",
    fill: "#9E7E00"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M358.268 249.653L358.383 249.371L359.588 249.818L359.48 250.1L358.268 249.653Z",
    fill: "#9E7E00"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M357.314 252.063L357.43 251.781L358.635 252.243L358.519 252.532L357.314 252.063Z",
    fill: "#9E7E00"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M355.165 257.484C355.901 255.687 356.594 253.876 357.315 252.072L358.52 252.541C357.799 254.36 357.099 256.185 356.356 257.996L355.165 257.491V257.484Z",
    fill: "#9E7E00"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M353.62 260.897L354.825 258.242L356.008 258.754L354.796 261.424L353.62 260.897Z",
    fill: "#9E7E00"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M352.798 262.721L353.202 261.826L354.378 262.36L353.967 263.262L352.798 262.721Z",
    fill: "#9E7E00"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M352.033 264.41L352.235 263.963L353.404 264.511L353.202 264.966L352.033 264.41Z",
    fill: "#9E7E00"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M351.492 265.579C351.572 265.434 351.637 265.283 351.701 265.139L352.863 265.694C352.798 265.846 352.726 265.997 352.654 266.142L351.492 265.579Z",
    fill: "#9E7E00"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M350.907 266.726L351.131 266.293L352.285 266.856L352.062 267.296L350.907 266.726Z",
    fill: "#9E7E00"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M350.323 267.874L350.547 267.441L351.701 268.011L351.47 268.451L350.323 267.874Z",
    fill: "#9E7E00"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M348.923 270.593L349.147 270.16L350.294 270.752L350.07 271.192L348.923 270.593Z",
    fill: "#9E7E00"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M347.171 273.941L347.416 273.516L348.549 274.136L348.304 274.562L347.171 273.941Z",
    fill: "#9E7E00"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M344.255 279.013L346.189 275.658L347.307 276.293L345.366 279.67L344.255 279.013Z",
    fill: "#9E7E00"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M341.629 283.321C342.148 282.499 342.69 281.683 343.195 280.854L344.299 281.525C343.786 282.361 343.245 283.184 342.718 284.007L341.629 283.321Z",
    fill: "#9E7E00"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M339.832 286.129L340.828 284.57L341.917 285.263L340.907 286.836L339.832 286.129Z",
    fill: "#9E7E00"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M338.179 288.682C338.359 288.43 338.518 288.163 338.684 287.91L339.752 288.624C339.579 288.884 339.427 289.151 339.24 289.404L338.172 288.682H338.179Z",
    fill: "#9E7E00"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M336.909 290.465L337.45 289.715L338.511 290.444L337.97 291.201L336.909 290.465Z",
    fill: "#9E7E00"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M336.021 291.72L336.375 291.223L337.429 291.966L337.075 292.471L336.021 291.72Z",
    fill: "#9E7E00"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M334.954 293.23L335.308 292.725L336.354 293.482L335.993 293.98L334.954 293.23Z",
    fill: "#9E7E00"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M333.886 294.728L334.239 294.23L335.278 294.988L334.918 295.493L333.886 294.728Z",
    fill: "#9E7E00"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M332.797 296.209L333.172 295.732L334.204 296.504L333.821 296.988L332.797 296.209Z",
    fill: "#9E7E00"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M331.656 297.659L332.031 297.176L333.056 297.962L332.674 298.446L331.656 297.659Z",
    fill: "#9E7E00"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M330.883 298.524L330.504 299.006L331.519 299.804L331.898 299.322L330.883 298.524Z",
    fill: "#9E7E00"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M328.431 301.763L328.618 301.525L329.621 302.334L329.426 302.579L328.431 301.763Z",
    fill: "#9E7E00"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M326.772 303.764L326.975 303.533L327.963 304.356L327.761 304.587L326.772 303.764Z",
    fill: "#9E7E00"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M325.075 305.719L325.277 305.488L326.259 306.332L326.056 306.563L325.075 305.719Z",
    fill: "#9E7E00"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M323.381 307.68L323.583 307.449L324.55 308.301L324.348 308.532L323.381 307.68Z",
    fill: "#9E7E00"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M321.671 309.63L321.887 309.406L322.84 310.272L322.623 310.496L321.671 309.63Z",
    fill: "#9E7E00"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M317.652 313.85L321.671 309.629L322.624 310.502L318.576 314.745L317.652 313.85Z",
    fill: "#9E7E00"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M315.033 316.52C315.748 315.863 316.411 315.149 317.082 314.449L318.006 315.351C317.328 316.058 316.664 316.78 315.942 317.436L315.033 316.52Z",
    fill: "#9E7E00"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M313.583 317.905L314.29 317.227L315.192 318.15L314.478 318.828L313.583 317.905Z",
    fill: "#9E7E00"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M312.589 318.825L312.234 319.164L313.126 320.099L313.481 319.76L312.589 318.825Z",
    fill: "#9E7E00"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M311.302 320.07L311.663 319.738L312.543 320.676L312.189 321.015L311.302 320.07Z",
    fill: "#9E7E00"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M310.372 320.964L310.726 320.625L311.606 321.57L311.245 321.909L310.372 320.964Z",
    fill: "#9E7E00"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M309.439 321.851L309.793 321.512L310.666 322.464L310.305 322.803L309.439 321.851Z",
    fill: "#9E7E00"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M307.133 323.851L307.501 323.533L308.359 324.5L307.984 324.825L307.133 323.851Z",
    fill: "#9E7E00"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M304.274 326.333L304.642 326.008L305.479 326.989L305.104 327.314L304.274 326.333Z",
    fill: "#9E7E00"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M299.736 330.019L302.774 327.623L303.597 328.619L300.537 331.029L299.736 330.019Z",
    fill: "#9E7E00"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M295.769 333.136L298.07 331.332L298.857 332.349L296.548 334.168L295.769 333.136Z",
    fill: "#9E7E00"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M293.055 335.07L294.563 334.002L295.328 335.034L293.805 336.116L293.055 335.07Z",
    fill: "#9E7E00"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M290.573 336.831L291.331 336.297L292.074 337.35L291.309 337.891L290.573 336.831Z",
    fill: "#9E7E00"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M288.79 338.1L289.54 337.566L290.276 338.627L289.512 339.168L288.79 338.1Z",
    fill: "#9E7E00"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M287.498 338.944L288.018 338.619L288.732 339.687L288.212 340.019L287.498 338.944Z",
    fill: "#9E7E00"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M285.947 339.941L286.467 339.609L287.174 340.692L286.654 341.024L285.947 339.941Z",
    fill: "#9E7E00"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M284.919 340.601L284.402 340.932L285.099 342.019L285.616 341.688L284.919 340.601Z",
    fill: "#9E7E00"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M282.847 341.932L283.366 341.6L284.052 342.689L283.532 343.021L282.847 341.932Z",
    fill: "#9E7E00"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M281.294 342.928L281.813 342.596L282.485 343.692L281.965 344.024L281.294 342.928Z",
    fill: "#9E7E00"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M279.705 343.852L280.239 343.549L280.903 344.653L280.369 344.963L279.705 343.852Z",
    fill: "#9E7E00"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M277.077 345.275L276.808 345.43L277.451 346.549L277.72 346.395L277.077 345.275Z",
    fill: "#9E7E00"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M274.532 346.831L274.792 346.68L275.42 347.805L275.153 347.957L274.532 346.831Z",
    fill: "#9E7E00"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M272.252 348.072L272.526 347.928L273.14 349.068L272.865 349.205L272.252 348.072Z",
    fill: "#9E7E00"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M269.952 349.256L270.219 349.111L270.818 350.259L270.544 350.396L269.952 349.256Z",
    fill: "#9E7E00"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M267.642 350.432L267.916 350.295L268.493 351.449L268.219 351.587L267.642 350.432Z",
    fill: "#9E7E00"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M262.382 352.943L265.037 351.745C265.917 351.341 266.769 350.872 267.635 350.432L268.212 351.586C267.339 352.026 266.48 352.495 265.593 352.907L262.923 354.112L262.382 352.943Z",
    fill: "#9E7E00"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M258.97 354.487L261.625 353.289L262.159 354.465L259.482 355.67L258.97 354.487Z",
    fill: "#9E7E00"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M257.144 355.309C257.447 355.186 257.743 355.042 258.039 354.912L258.544 356.095C258.241 356.225 257.945 356.37 257.642 356.499L257.137 355.309H257.144Z",
    fill: "#9E7E00"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M255.418 355.987L255.873 355.807L256.363 357.004L255.909 357.185L255.418 355.987Z",
    fill: "#9E7E00"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M254.222 356.464L254.676 356.283L255.16 357.474L254.698 357.661L254.222 356.464Z",
    fill: "#9E7E00"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M253.524 356.646L253.067 356.826L253.541 358.028L253.997 357.848L253.524 356.646Z",
    fill: "#9E7E00"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M251.825 357.409L252.28 357.229L252.742 358.426L252.287 358.607L251.825 357.409Z",
    fill: "#9E7E00"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M248.976 358.526L249.437 358.346L249.885 359.558L249.423 359.738L248.976 358.526Z",
    fill: "#9E7E00"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M245.396 359.747L245.866 359.588L246.284 360.807L245.815 360.966L245.396 359.747Z",
    fill: "#9E7E00"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M239.849 361.6C241.083 361.232 242.295 360.785 243.522 360.381L243.926 361.607C242.692 362.012 241.473 362.466 240.224 362.834L239.842 361.6H239.849Z",
    fill: "#9E7E00"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M235 362.971L237.814 362.178L238.175 363.412L235.346 364.22L235 362.971Z",
    fill: "#9E7E00"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M231.788 363.888L233.57 363.383L233.902 364.624L232.113 365.136L231.788 363.888Z",
    fill: "#9E7E00"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M228.83 364.58L229.732 364.371L230.042 365.627L229.133 365.836L228.83 364.58Z",
    fill: "#9E7E00"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M226.694 365.073L227.596 364.863L227.892 366.119L226.983 366.335L226.694 365.073Z",
    fill: "#9E7E00"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M225.193 365.418L225.792 365.281L226.074 366.544L225.468 366.681L225.193 365.418Z",
    fill: "#9E7E00"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M223.397 365.836L223.996 365.699L224.263 366.962L223.664 367.099L223.397 365.836Z",
    fill: "#9E7E00"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M221.594 366.198L222.193 366.09L222.452 367.353L221.846 367.461L221.594 366.198Z",
    fill: "#9E7E00"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M219.782 366.522L220.381 366.414L220.626 367.677L220.02 367.785L219.782 366.522Z",
    fill: "#9E7E00"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M218.608 366.685L218.004 366.793L218.231 368.064L218.835 367.957L218.608 366.685Z",
    fill: "#9E7E00"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M216.151 367.171L216.75 367.062L216.967 368.332L216.361 368.441L216.151 367.171Z",
    fill: "#9E7E00"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M212.818 367.727L213.121 367.684L213.316 368.961L213.006 368.997L212.818 367.727Z",
    fill: "#9E7E00"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M210.251 368.051L210.554 368.008L210.727 369.292L210.417 369.328L210.251 368.051Z",
    fill: "#9E7E00"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M207.674 368.376L207.977 368.34L208.136 369.617L207.833 369.66L207.674 368.376Z",
    fill: "#9E7E00"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M205.105 368.7L205.409 368.664L205.546 369.948L205.243 369.985L205.105 368.7Z",
    fill: "#9E7E00"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M202.522 368.94L202.833 368.918L202.948 370.202L202.645 370.224L202.522 368.94Z",
    fill: "#9E7E00"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M196.715 369.38L202.523 368.939L202.639 370.224L196.787 370.671L196.715 369.38Z",
    fill: "#9E7E00"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M192.97 369.559C193.937 369.523 194.911 369.537 195.878 369.443L195.95 370.728C194.976 370.821 193.994 370.814 193.02 370.843L192.97 369.552V369.559Z",
    fill: "#9E7E00"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M190.97 369.612L191.951 369.59L191.994 370.874L191.006 370.903L190.97 369.612Z",
    fill: "#9E7E00"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M189.116 369.661L189.607 369.646L189.636 370.938L189.138 370.945L189.116 369.661Z",
    fill: "#9E7E00"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M187.824 369.689L188.315 369.682L188.337 370.966L187.846 370.98L187.824 369.689Z",
    fill: "#9E7E00"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M186.54 369.725L187.031 369.711L187.038 371.002L186.547 371.01L186.54 369.725Z",
    fill: "#9E7E00"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M185.249 369.74C185.415 369.74 185.574 369.747 185.74 369.74V371.032C185.574 371.039 185.415 371.032 185.249 371.032V369.74Z",
    fill: "#9E7E00"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M182.196 369.668L182.687 369.675L182.665 370.967L182.175 370.952L182.196 369.668Z",
    fill: "#9E7E00"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M178.416 369.566L178.906 369.581L178.856 370.872L178.365 370.858L178.416 369.566Z",
    fill: "#9E7E00"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M172.571 369.25C173.856 369.337 175.14 369.466 176.432 369.524L176.367 370.816C175.068 370.758 173.776 370.628 172.478 370.542L172.564 369.257L172.571 369.25Z",
    fill: "#9E7E00"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M167.549 368.867L170.464 369.084L170.356 370.368L167.419 370.144L167.549 368.867Z",
    fill: "#9E7E00"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M164.23 368.484L166.07 368.723L165.933 370L164.086 369.769L164.23 368.484Z",
    fill: "#9E7E00"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M161.214 368.102L162.137 368.217L161.971 369.501L161.048 369.379L161.214 368.102Z",
    fill: "#9E7E00"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M159.043 367.828L159.959 367.944L159.786 369.221L158.862 369.105L159.043 367.828Z",
    fill: "#9E7E00"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M157.512 367.633L158.118 367.712L157.931 368.982L157.317 368.91L157.512 367.633Z",
    fill: "#9E7E00"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M155.702 367.309L156.301 367.417L156.099 368.694L155.493 368.586L155.702 367.309Z",
    fill: "#9E7E00"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M153.883 366.992L154.49 367.093L154.273 368.37L153.667 368.262L153.883 366.992Z",
    fill: "#9E7E00"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M152.072 366.666L152.678 366.774L152.447 368.037L151.841 367.929L152.072 366.666Z",
    fill: "#9E7E00"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M150.261 366.342L150.86 366.45L150.622 367.713L150.016 367.604L150.261 366.342Z",
    fill: "#9E7E00"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M148.443 366.018L149.049 366.126L148.797 367.388L148.19 367.28L148.443 366.018Z",
    fill: "#9E7E00"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M145.152 365.26L145.447 365.325L145.173 366.587L144.87 366.515L145.152 365.26Z",
    fill: "#9E7E00"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M142.626 364.676L142.922 364.748L142.626 366.003L142.323 365.931L142.626 364.676Z",
    fill: "#9E7E00"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M140.102 364.092L140.397 364.164L140.087 365.412L139.784 365.347L140.102 364.092Z",
    fill: "#9E7E00"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M137.598 363.412L137.893 363.499L137.561 364.747L137.266 364.66L137.598 363.412Z",
    fill: "#9E7E00"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M135.076 362.625L134.723 363.867L135.021 363.952L135.374 362.71L135.076 362.625Z",
    fill: "#9E7E00"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M129.518 361.055C129.98 361.206 130.434 361.372 130.903 361.516L132.303 361.913L135.103 362.707L134.749 363.948L131.928 363.147L130.514 362.743C130.045 362.606 129.583 362.433 129.121 362.281L129.511 361.055H129.518Z",
    fill: "#9E7E00"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M125.975 359.855L128.731 360.786L128.335 362.013L125.557 361.075L125.975 359.855Z",
    fill: "#9E7E00"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M124.077 359.215L125.001 359.525L124.583 360.745L123.645 360.427L124.077 359.215Z",
    fill: "#9E7E00"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M122.316 358.623L122.778 358.775L122.345 359.987L121.876 359.828L122.316 358.623Z",
    fill: "#9E7E00"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M121.118 358.152L121.572 358.333L121.125 359.538L120.663 359.357L121.118 358.152Z",
    fill: "#9E7E00"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M119.921 357.676L120.375 357.856L119.921 359.068L119.459 358.881L119.921 357.676Z",
    fill: "#9E7E00"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M118.723 357.207L119.178 357.387L118.708 358.592L118.254 358.412L118.723 357.207Z",
    fill: "#9E7E00"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M115.872 356.09L116.334 356.27L115.843 357.461L115.389 357.28L115.872 356.09Z",
    fill: "#9E7E00"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M112.387 354.633L112.835 354.835L112.322 356.018L111.875 355.816L112.387 354.633Z",
    fill: "#9E7E00"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M107.054 352.223L110.583 353.81L110.056 354.993L106.506 353.384L107.054 352.223Z",
    fill: "#9E7E00"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M102.539 349.984L105.136 351.319L104.573 352.481L101.954 351.139L102.539 349.984Z",
    fill: "#9E7E00"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5651 348.463L101.21 349.307L100.618 350.454L98.959 349.61L99.5651 348.463Z",
    fill: "#9E7E00"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M96.8822 347.041L97.6831 347.503L97.0698 348.636L96.2617 348.174L96.8822 347.041Z",
    fill: "#9E7E00"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M94.9846 345.951L95.7855 346.413L95.1577 347.539L94.3496 347.07L94.9846 345.951Z",
    fill: "#9E7E00"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6484 345.18L94.1751 345.483L93.533 346.601L92.999 346.298L93.6484 345.18Z",
    fill: "#9E7E00"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0472 344.264L92.5811 344.567L91.9318 345.678L91.3906 345.375L92.0472 344.264Z",
    fill: "#9E7E00"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4519 343.348L90.9859 343.651L90.3221 344.755L89.7881 344.452L90.4519 343.348Z",
    fill: "#9E7E00"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8872 342.373L89.4068 342.705L88.7285 343.802L88.209 343.47L88.8872 342.373Z",
    fill: "#9E7E00"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M87.3349 341.377L87.8544 341.709L87.1689 342.798L86.6494 342.466L87.3349 341.377Z",
    fill: "#9E7E00"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M85.7898 340.385L85.0928 341.473L85.6092 341.804L86.3062 340.716L85.7898 340.385Z",
    fill: "#9E7E00"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M82.9403 338.557L83.2 338.723L82.4785 339.798L82.2188 339.632L82.9403 338.557Z",
    fill: "#9E7E00"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M80.8108 337.076L81.0633 337.257L80.3273 338.317L80.082 338.137L80.8108 337.076Z",
    fill: "#9E7E00"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7083 335.494L77.96 336.547L78.2129 336.727L78.9612 335.674L78.7083 335.494Z",
    fill: "#9E7E00"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M76.592 334.076L76.8373 334.249L76.0797 335.288L75.8271 335.115L76.592 334.076Z",
    fill: "#9E7E00"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5078 332.531L74.7458 332.719L73.9738 333.751L73.7285 333.563L74.5078 332.531Z",
    fill: "#9E7E00"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9243 328.93L74.5061 332.53L73.7269 333.555L69.1162 329.933L69.9243 328.93Z",
    fill: "#9E7E00"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0329 326.549L68.1369 327.501C68.5049 327.819 68.8945 328.107 69.2769 328.41L68.4616 329.413C68.0791 329.11 67.6823 328.822 67.3143 328.497L66.2031 327.537L67.0329 326.549Z",
    fill: "#9E7E00"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5157 325.244L66.2588 325.886L65.4219 326.868L64.6787 326.218L65.5157 325.244Z",
    fill: "#9E7E00"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M64.117 324.023L64.485 324.348L63.6408 325.315L63.2656 324.998L64.117 324.023Z",
    fill: "#9E7E00"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M63.1419 323.18L63.5099 323.504L62.6584 324.471L62.2832 324.147L63.1419 323.18Z",
    fill: "#9E7E00"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1667 322.344L62.5347 322.661L61.676 323.621L61.3008 323.296L62.1667 322.344Z",
    fill: "#9E7E00"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2168 321.477L61.5703 321.816L60.7045 322.768L60.3438 322.429L61.2168 321.477Z",
    fill: "#9E7E00"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0008 319.363L59.3543 319.702L58.4741 320.64L58.1133 320.301L59.0008 319.363Z",
    fill: "#9E7E00"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2666 316.758L56.6201 317.09L55.7182 318.013L55.3574 317.674L56.2666 316.758Z",
    fill: "#9E7E00"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1821 312.566L54.8519 315.373L53.9355 316.275L51.2441 313.461L52.1821 312.566Z",
    fill: "#9E7E00"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7253 308.9C49.0356 309.276 49.3747 309.629 49.7138 309.983L50.724 311.043L49.7788 311.924L48.7614 310.856C48.4222 310.502 48.0831 310.149 47.7656 309.766L48.7253 308.9Z",
    fill: "#9E7E00"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5385 306.375L47.7507 307.775L46.7838 308.633L45.5645 307.219L46.5385 306.375Z",
    fill: "#9E7E00"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5491 304.08L45.1551 304.78L44.1738 305.61L43.5605 304.91L44.5491 304.08Z",
    fill: "#9E7E00"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M43.126 302.414C43.3136 302.659 43.5156 302.89 43.7176 303.128L42.7219 303.951C42.5199 303.72 42.3106 303.482 42.123 303.237L43.1188 302.421L43.126 302.414Z",
    fill: "#9E7E00"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1739 301.201L42.5491 301.677L41.5533 302.493L41.1709 302.009L42.1739 301.201Z",
    fill: "#9E7E00"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0346 299.752L41.417 300.235L40.4069 301.036L40.0244 300.553L41.0346 299.752Z",
    fill: "#9E7E00"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9016 298.301L40.2767 298.784L39.2594 299.578L38.877 299.095L39.9016 298.301Z",
    fill: "#9E7E00"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7603 296.852L39.1355 297.335L38.1109 298.121L37.7285 297.631L38.7603 296.852Z",
    fill: "#9E7E00"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6354 295.394C37.758 295.56 37.8663 295.733 37.9961 295.885L36.9643 296.657C36.8344 296.498 36.719 296.325 36.6035 296.159L37.6354 295.387V295.394Z",
    fill: "#9E7E00"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5674 293.893L36.9209 294.39L35.8819 295.155L35.5283 294.65L36.5674 293.893Z",
    fill: "#9E7E00"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M34.612 291.137L34.7852 291.389L33.7318 292.125L33.5586 291.88L34.612 291.137Z",
    fill: "#9E7E00"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1119 289.023L33.285 289.276L32.2243 290.005L32.0439 289.752L33.1119 289.023Z",
    fill: "#9E7E00"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6835 286.857L31.8495 287.117L30.7744 287.831L30.6084 287.572L31.6835 286.857Z",
    fill: "#9E7E00"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2866 284.674L29.1992 285.371L29.3666 285.632L30.454 284.935L30.2866 284.674Z",
    fill: "#9E7E00"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8897 282.492L29.0557 282.752L27.9589 283.43L27.793 283.178L28.8897 282.492Z",
    fill: "#9E7E00"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9108 277.484L27.3611 280.01C27.6064 280.428 27.8373 280.861 28.0971 281.265L28.8835 282.492L27.7868 283.17L26.9931 281.936C26.7261 281.525 26.5024 281.092 26.2499 280.674L24.7852 278.134L25.9036 277.492L25.9108 277.484Z",
    fill: "#9E7E00"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0416 274.236L25.4991 276.762L24.3735 277.404L22.916 274.857L24.0416 274.236Z",
    fill: "#9E7E00"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0893 272.477L23.5366 273.35L22.4038 273.963L21.9492 273.09L23.0893 272.477Z",
    fill: "#9E7E00"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2459 270.824L22.4624 271.264L21.3223 271.863L21.0986 271.423L22.2459 270.824Z",
    fill: "#9E7E00"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6522 269.684L21.8758 270.117L20.7286 270.708L20.5049 270.268L21.6522 269.684Z",
    fill: "#9E7E00"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0695 268.537L21.2932 268.97L20.1387 269.555L19.915 269.114L21.0695 268.537Z",
    fill: "#9E7E00"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4768 267.389L20.7004 267.822L19.5459 268.399L19.3223 267.959L20.4768 267.389Z",
    fill: "#9E7E00"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1216 264.648L19.3236 265.096L18.162 265.651L17.96 265.204L19.1216 264.648Z",
    fill: "#9E7E00"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6007 261.124L16.4238 261.656L16.626 262.103L17.8028 261.571L17.6007 261.124Z",
    fill: "#9E7E00"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2247 255.844C15.6721 257.056 16.2204 258.225 16.7544 259.401L15.5711 259.92C15.0371 258.737 14.4888 257.561 14.0342 256.342L15.2247 255.851V255.844Z",
    fill: "#9E7E00"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M13.371 251.154L14.4461 253.875L13.2483 254.351L12.166 251.609L13.371 251.154Z",
    fill: "#9E7E00"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1868 248.031L12.4898 248.912L12.8289 249.77L11.6167 250.225L11.2776 249.352L10.9746 248.471L12.1868 248.031Z",
    fill: "#9E7E00"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2135 245.158L11.5094 246.031L10.29 246.457L9.99414 245.569L11.2135 245.158Z",
    fill: "#9E7E00"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5128 243.082L10.8086 243.955L9.58195 244.366L9.28613 243.486L10.5128 243.082Z",
    fill: "#9E7E00"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0157 241.623L10.2177 242.2L8.98389 242.597L8.78906 242.013L10.0157 241.623Z",
    fill: "#9E7E00"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M9.44572 239.871C9.50345 240.065 9.55399 240.267 9.61893 240.455L8.38508 240.837C8.31292 240.643 8.26964 240.441 8.21191 240.246L9.44572 239.863V239.871Z",
    fill: "#9E7E00"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94713 238.096L9.11307 238.687L7.87922 239.055L7.70605 238.464L8.94713 238.096Z",
    fill: "#9E7E00"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44225 236.326L8.60819 236.911L7.37434 237.271L7.20117 236.68L8.44225 236.326Z",
    fill: "#9E7E00"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93639 234.553L8.10233 235.137L6.8613 235.491L6.69531 234.892L7.93639 234.553Z",
    fill: "#9E7E00"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M7.43146 232.777L7.60463 233.369L6.35637 233.701L6.19043 233.109L7.43146 232.777Z",
    fill: "#9E7E00"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M6.61583 229.502L6.68079 229.805L5.43249 230.108L5.36035 229.812L6.61583 229.502Z",
    fill: "#9E7E00"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M6.027 226.989L4.76855 227.279L4.83834 227.582L6.09678 227.291L6.027 226.989Z",
    fill: "#9E7E00"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M5.44727 224.451L5.51945 224.747L4.25675 225.021L4.18457 224.725L5.44727 224.451Z",
    fill: "#9E7E00"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M4.89844 221.918L4.95618 222.221L3.69348 222.474L3.63574 222.17L4.89844 221.918Z",
    fill: "#9E7E00"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44468 219.363L4.50242 219.666L3.2325 219.904L3.1748 219.601L4.44468 219.363Z",
    fill: "#9E7E00"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41972 213.627L4.4443 219.363L3.17442 219.601L2.14258 213.822L3.41972 213.627Z",
    fill: "#9E7E00"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94414 209.91L3.31209 212.804L2.03499 212.991L1.66699 210.083L2.94414 209.91Z",
    fill: "#9E7E00"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M2.69116 207.926L2.81386 208.9L1.53671 209.059L1.41406 208.077L2.69116 207.926Z",
    fill: "#9E7E00"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M2.4601 206.086L2.51784 206.569L1.2407 206.714L1.17578 206.23L2.4601 206.086Z",
    fill: "#9E7E00"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M2.29472 204.809L2.35968 205.292L1.07531 205.429L1.01758 204.939L2.29472 204.809Z",
    fill: "#9E7E00"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1789 203.525L2.21497 204.016L0.9306 204.146L0.894531 203.648L2.1789 203.525Z",
    fill: "#9E7E00"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07831 202.24L2.11438 202.731L0.830058 202.846L0.793945 202.356L2.07831 202.24Z",
    fill: "#9E7E00"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M1.782 199.252L0.494141 199.35L0.531181 199.839L1.81904 199.741L1.782 199.252Z",
    fill: "#9E7E00"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55776 195.422L1.59387 195.913L0.309506 195.985L0.273438 195.487L1.55776 195.422Z",
    fill: "#9E7E00"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39213 189.578L1.48594 193.446L0.201568 193.496L0.100586 189.6L1.39213 189.578Z",
    fill: "#9E7E00"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M1.31331 184.535C1.27001 185.509 1.31328 186.483 1.33493 187.457L0.0433828 187.471C0.0217365 186.49 -0.0287926 185.509 0.0217154 184.527H1.31331V184.535Z",
    fill: "#9E7E00"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39968 181.193L1.34916 183.047L0.0576172 183.033L0.10813 181.164L1.39968 181.193Z",
    fill: "#9E7E00"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M1.47142 178.156L1.44979 179.087L0.158203 179.044L0.187093 178.105L1.47142 178.156Z",
    fill: "#9E7E00"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52903 175.969L1.50737 176.893L0.21582 176.835L0.244666 175.904L1.52903 175.969Z",
    fill: "#9E7E00"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6532 174.433L1.60268 175.039L0.318359 174.967L0.36165 174.354L1.6532 174.433Z",
    fill: "#9E7E00"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M1.78894 172.592L1.74565 173.206L0.454102 173.119L0.504615 172.506L1.78894 172.592Z",
    fill: "#9E7E00"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M0.690072 170.711L0.643555 171.322L1.93134 171.42L1.97785 170.809L0.690072 170.711Z",
    fill: "#9E7E00"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07116 168.92L2.02065 169.533L0.736328 169.418L0.786797 168.805L2.07116 168.92Z",
    fill: "#9E7E00"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M2.20754 167.08L2.16425 167.693L0.879883 167.57L0.923174 166.957L2.20754 167.08Z",
    fill: "#9E7E00"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M2.41705 165.254L2.34491 165.86L1.06055 165.723L1.13995 165.109L2.41705 165.254Z",
    fill: "#9E7E00"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M1.54414 161.696L1.50488 162.004L2.78609 162.167L2.82535 161.86L1.54414 161.696Z",
    fill: "#9E7E00"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M3.17493 159.331L3.13159 159.634L1.85449 159.453L1.89778 159.15L3.17493 159.331Z",
    fill: "#9E7E00"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53567 156.761L3.47793 157.064L2.20801 156.869L2.25852 156.566L3.53567 156.761Z",
    fill: "#9E7E00"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9907 154.214L3.94023 154.51L2.66309 154.293L2.72082 153.99L3.9907 154.214Z",
    fill: "#9E7E00"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M4.44442 151.66L4.3939 151.963L3.12402 151.725L3.17454 151.422L4.44442 151.66Z",
    fill: "#9E7E00"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59196 145.947C5.38271 146.893 5.13738 147.838 4.95699 148.79L4.44468 151.655L3.1748 151.417L3.68707 148.531C3.86746 147.571 4.11279 146.626 4.32926 145.666L5.59196 145.94V145.947Z",
    fill: "#9E7E00"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M6.43648 142.296L5.77989 145.139L4.52441 144.857L5.181 142L6.43648 142.296Z",
    fill: "#9E7E00"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M6.88306 140.347L6.66661 141.299L5.41113 140.989L5.63481 140.029L6.88306 140.347Z",
    fill: "#9E7E00"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3541 138.551L7.21701 139.02L5.96875 138.696L6.10584 138.227L7.3541 138.551Z",
    fill: "#9E7E00"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69942 137.31L7.56954 137.787L6.32129 137.448L6.45838 136.979L7.69942 137.31Z",
    fill: "#9E7E00"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05293 136.077L7.92306 136.546L6.6748 136.207L6.8119 135.73L8.05293 136.077Z",
    fill: "#9E7E00"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M8.40649 134.836L8.2694 135.305L7.02832 134.959L7.16542 134.482L8.40649 134.836Z",
    fill: "#9E7E00"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M9.24302 131.891L9.10592 132.367L7.87207 131.992L8.00917 131.516L9.24302 131.891Z",
    fill: "#9E7E00"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3971 128.291L10.2384 128.76L9.01172 128.364L9.17048 127.895L10.3971 128.291Z",
    fill: "#9E7E00"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2671 122.749L11.0333 126.414L9.80664 126.003L11.0549 122.309L12.2671 122.749Z",
    fill: "#9E7E00"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0916 118.052L13.0165 120.773L11.8115 120.318L12.8938 117.576L14.0916 118.052Z",
    fill: "#9E7E00"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3174 114.942L14.6319 116.666L13.4414 116.183L14.1197 114.451L15.3174 114.942Z",
    fill: "#9E7E00"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5081 112.156L16.1257 112.993L14.9424 112.488L15.3248 111.637L16.5081 112.156Z",
    fill: "#9E7E00"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4111 110.158L17.0359 111.002L15.8525 110.475L16.235 109.631L17.4111 110.158Z",
    fill: "#9E7E00"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0455 108.751L17.7929 109.306L16.624 108.772L16.8766 108.217L18.0455 108.751Z",
    fill: "#9E7E00"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8111 107.07L18.5585 107.633L17.3896 107.084L17.6422 106.521L18.8111 107.07Z",
    fill: "#9E7E00"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5761 105.403C19.4823 105.584 19.3957 105.771 19.3091 105.959L18.1475 105.403C18.234 105.216 18.3134 105.028 18.4144 104.848L19.5761 105.41V105.403Z",
    fill: "#9E7E00"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M20.4202 103.759L20.1388 104.308L18.9844 103.738L19.2658 103.189L20.4202 103.759Z",
    fill: "#9E7E00"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2568 102.12L20.9826 102.668L19.8281 102.084L20.1095 101.535L21.2568 102.12Z",
    fill: "#9E7E00"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1005 100.482L21.8191 101.023L20.6719 100.431L20.9532 99.8828L22.1005 100.482Z",
    fill: "#9E7E00"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6525 97.4805C23.602 97.5671 23.5515 97.6536 23.501 97.7474L22.3682 97.1342C22.4115 97.0404 22.4692 96.9538 22.5197 96.8672L23.6525 97.4877V97.4805Z",
    fill: "#9E7E00"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9451 95.2293L24.7864 95.4963L23.668 94.8685L23.8195 94.6016L24.9451 95.2293Z",
    fill: "#9E7E00"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2357 92.9853L26.0842 93.2523L24.9658 92.6029L25.1174 92.3359L26.2357 92.9853Z",
    fill: "#9E7E00"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5264 90.7414L27.3748 91.0011L26.2637 90.3373L26.4224 90.0703L27.5264 90.7414Z",
    fill: "#9E7E00"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8906 88.5337L28.7247 88.7934L27.6279 88.1152L27.7939 87.8555L28.8906 88.5337Z",
    fill: "#9E7E00"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0356 83.6265L28.8897 88.533L27.793 87.8475L30.9605 82.9121L32.0356 83.6265Z",
    fill: "#9E7E00"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1507 80.5387C33.5951 81.3396 33.0034 82.1044 32.4839 82.927L31.416 82.2054C31.9427 81.3829 32.5416 80.6036 33.0972 79.8027L34.1579 80.5387H34.1507Z",
    fill: "#9E7E00"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3119 78.9086L34.7419 79.7023L33.6885 78.9663L34.2585 78.1582L35.3119 78.9086Z",
    fill: "#9E7E00"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3882 77.3924L36.1068 77.7964L35.0605 77.0389L35.342 76.6348L36.3882 77.3924Z",
    fill: "#9E7E00"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1309 76.3468L36.8495 76.7437L35.8105 75.9788L36.0992 75.582L37.1309 76.3468Z",
    fill: "#9E7E00"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8819 75.2935L37.6005 75.6975L36.5615 74.9255L36.8501 74.5215L37.8819 75.2935Z",
    fill: "#9E7E00"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6753 74.2831L38.3723 74.6656L37.3477 73.8935L37.6507 73.5039L38.6753 74.2831Z",
    fill: "#9E7E00"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5532 71.1201L39.25 71.5059L40.2654 72.3041L40.5687 71.9183L39.5532 71.1201Z",
    fill: "#9E7E00"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M42.9026 68.9085L42.5996 69.2909L41.5967 68.4756L41.8997 68.0859L42.9026 68.9085Z",
    fill: "#9E7E00"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7057 64.4628L44.1731 67.3851L43.1846 66.5553L45.7316 63.6113L46.7057 64.4628Z",
    fill: "#9E7E00"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0541 60.6894C49.7222 61.043 49.3759 61.3893 49.0512 61.7501L48.0915 62.8541L47.1318 61.9954L48.0988 60.8843C48.4235 60.5163 48.7697 60.17 49.1089 59.8164L50.0541 60.6894Z",
    fill: "#9E7E00"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3557 58.2722L51.0787 59.6143L50.1406 58.734L51.425 57.3848L52.3557 58.2722Z",
    fill: "#9E7E00"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4553 56.0791L53.8132 56.7429L52.8896 55.8482L53.5317 55.1699L54.4553 56.0791Z",
    fill: "#9E7E00"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9991 54.5277L55.3281 55.1626L54.4189 54.2535L55.0899 53.6113L55.9991 54.5277Z",
    fill: "#9E7E00"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1169 53.4587L56.6695 53.8844L55.7676 52.9608L56.2149 52.5352L57.1169 53.4587Z",
    fill: "#9E7E00"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5513 51.2409L57.1074 51.6641L57.9986 52.5989L58.4425 52.1758L57.5513 51.2409Z",
    fill: "#9E7E00"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7798 50.9198L59.3396 51.3383L58.4521 50.4003L58.8995 49.9746L59.7798 50.9198Z",
    fill: "#9E7E00"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M61.1149 49.6497L60.6748 50.0682L59.8018 49.123L60.2419 48.6973L61.1149 49.6497Z",
    fill: "#9E7E00"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4858 48.4167L62.024 48.8135L61.1582 47.8611L61.62 47.457L62.4858 48.4167Z",
    fill: "#9E7E00"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8781 47.2104L63.4163 47.6073L62.5576 46.6404L63.0266 46.2363L63.8781 47.2104Z",
    fill: "#9E7E00"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4331 44.995L66.2022 45.197L65.3652 44.2157L65.5962 44.0137L66.4331 44.995Z",
    fill: "#9E7E00"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3943 43.2998C68.315 43.3575 68.2355 43.4297 68.1634 43.4946L67.3408 42.4989C67.4202 42.4339 67.4924 42.3618 67.579 42.2969L68.4016 43.2926L68.3943 43.2998Z",
    fill: "#9E7E00"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M70.43 41.6983L70.1919 41.8859L69.3838 40.8829L69.6219 40.6953L70.43 41.6983Z",
    fill: "#9E7E00"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M72.4716 40.0974L72.2263 40.285L71.4326 39.2749L71.6779 39.0801L72.4716 40.0974Z",
    fill: "#9E7E00"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M74.5067 38.4953L74.2686 38.6829L73.4893 37.6583L73.7274 37.4707L74.5067 38.4953Z",
    fill: "#9E7E00"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2267 35.0822L76.8528 36.7706C76.0663 37.3334 75.2582 37.8817 74.5078 38.4951L73.7285 37.4633C74.4861 36.8427 75.2942 36.2943 76.0879 35.7243L78.4762 34.0215L79.2194 35.075L79.2267 35.0822Z",
    fill: "#9E7E00"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2779 32.9097L79.904 34.5981L79.168 33.5447L81.5563 31.8418L82.2779 32.9097Z",
    fill: "#9E7E00"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9592 31.8212L83.1366 32.3479L82.415 31.2728L83.2448 30.7461L83.9592 31.8212Z",
    fill: "#9E7E00"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5175 30.8167L85.1061 31.0764L84.4062 30.0013L84.8176 29.7344L85.5175 30.8167Z",
    fill: "#9E7E00"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9179 28.9774L85.5049 29.2422L86.2021 30.3294L86.615 30.0646L85.9179 28.9774Z",
    fill: "#9E7E00"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M87.6899 29.4255L87.2786 29.6924L86.5859 28.6029L87.0044 28.3359L87.6899 29.4255Z",
    fill: "#9E7E00"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M88.7722 28.7315L88.3608 28.9913L87.6826 27.9017L88.0939 27.6348L88.7722 28.7315Z",
    fill: "#9E7E00"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M91.3903 27.145L90.9645 27.3903L90.3008 26.2864L90.7265 26.041L91.3903 27.145Z",
    fill: "#9E7E00"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M94.6665 25.261L94.2408 25.5063L93.5986 24.3879L94.0315 24.1426L94.6665 25.261Z",
    fill: "#9E7E00"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7897 22.4467L98.0652 23.327C97.488 23.6156 96.9396 23.9619 96.3768 24.2722L95.749 23.1466C96.319 22.8291 96.8675 22.4827 97.4447 22.1941L99.1764 21.3066L99.7753 22.4467H99.7897Z",
    fill: "#9E7E00"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M104.278 20.1467L101.681 21.4815L101.089 20.3343L103.715 18.9922L104.278 20.1467Z",
    fill: "#9E7E00"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M107.286 18.7021L105.605 19.4669L105.042 18.3053L106.738 17.5332L107.286 18.7021Z",
    fill: "#9E7E00"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M110.058 17.4554L109.214 17.8378L108.68 16.6617L109.531 16.2793L110.058 17.4554Z",
    fill: "#9E7E00"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M112.056 16.5524L111.212 16.9349L110.692 15.7515L111.537 15.3691L112.056 16.5524Z",
    fill: "#9E7E00"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M113.463 15.9171L112.901 16.1696L112.396 14.9791L112.958 14.7266L113.463 15.9171Z",
    fill: "#9E7E00"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M115.167 15.2251L114.596 15.4488L114.099 14.2582L114.676 14.0273L115.167 15.2251Z",
    fill: "#9E7E00"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M116.883 14.5454L116.313 14.7691L115.822 13.5713L116.399 13.3477L116.883 14.5454Z",
    fill: "#9E7E00"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M118.134 12.6344L117.563 12.8594L118.037 14.0609L118.608 13.8359L118.134 12.6344Z",
    fill: "#9E7E00"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M120.309 13.1966L119.739 13.4202L119.277 12.2153L119.847 11.9844L120.309 13.1966Z",
    fill: "#9E7E00"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M122.02 12.5188L121.45 12.7425L121.003 11.5303L121.58 11.3066L122.02 12.5188Z",
    fill: "#9E7E00"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M125.216 11.4303L124.928 11.5242L124.502 10.312L124.798 10.2109L125.216 11.4303Z",
    fill: "#9E7E00"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M127.677 10.5996L127.382 10.6934L126.978 9.47403L127.273 9.37305L127.677 10.5996Z",
    fill: "#9E7E00"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M130.13 9.76374L129.842 9.86477L129.452 8.63814L129.741 8.53711L130.13 9.76374Z",
    fill: "#9E7E00"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M132.612 9.02678L132.316 9.11336L131.948 7.87955L132.244 7.79297L132.612 9.02678Z",
    fill: "#9E7E00"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M134.797 7.00694L134.498 7.0918L134.851 8.33411L135.15 8.24926L134.797 7.00694Z",
    fill: "#9E7E00"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M140.73 6.79063C140.261 6.90608 139.785 6.99986 139.316 7.12974L137.916 7.52662L135.116 8.3203L134.763 7.07927L137.584 6.27832L138.998 5.87426C139.467 5.74438 139.951 5.6506 140.427 5.53516L140.737 6.78341L140.73 6.79063Z",
    fill: "#9E7E00"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M144.38 5.94493L141.537 6.60152L141.234 5.34604L144.092 4.68945L144.38 5.94493Z",
    fill: "#9E7E00"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M146.331 5.49903L145.378 5.71548L145.097 4.46L146.056 4.23633L146.331 5.49903Z",
    fill: "#9E7E00"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M148.141 5.07911L147.664 5.18731L147.397 3.92461L147.881 3.81641L148.141 5.07911Z",
    fill: "#9E7E00"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M149.404 4.84083L148.92 4.92741L148.668 3.66471L149.151 3.57812L149.404 4.84083Z",
    fill: "#9E7E00"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M150.672 4.61036L150.189 4.69694L149.943 3.43424L150.427 3.34766L150.672 4.61036Z",
    fill: "#9E7E00"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M151.942 4.38711L151.459 4.47369L151.221 3.20377L151.704 3.11719L151.942 4.38711Z",
    fill: "#9E7E00"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M154.952 3.85332L154.468 3.9399L154.252 2.66275L154.735 2.57617L154.952 3.85332Z",
    fill: "#9E7E00"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M158.682 3.24785L158.199 3.30554L158.004 2.03562L158.495 1.9707L158.682 3.24785Z",
    fill: "#9E7E00"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M164.482 2.51093L160.644 2.99435L160.471 1.71721L164.338 1.22656L164.482 2.51093Z",
    fill: "#9E7E00"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M169.504 2.01288L166.589 2.24378L166.452 0.959415L169.389 0.728516L169.504 2.01288Z",
    fill: "#9E7E00"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M172.831 1.76089L170.984 1.9052L170.883 0.613657L172.744 0.476562L172.831 1.76089Z",
    fill: "#9E7E00"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M175.862 1.53046L174.938 1.6026L174.866 0.311052L175.79 0.246094L175.862 1.53046Z",
    fill: "#9E7E00"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M178.048 1.46596L177.124 1.48763L177.066 0.203264L177.997 0.181641L178.048 1.46596Z",
    fill: "#9E7E00"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M179.592 1.42831L178.979 1.44275L178.936 0.151164L179.549 0.136719L179.592 1.42831Z",
    fill: "#9E7E00"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M181.374 0.132916L180.761 0.148438L180.793 1.43961L181.407 1.42409L181.374 0.132916Z",
    fill: "#9E7E00"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M183.271 1.33451L182.665 1.34896L182.644 0.0573697L183.257 0.0429688L183.271 1.33451Z",
    fill: "#9E7E00"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M185.119 1.28432L184.505 1.30599L184.498 0.0144009L185.111 0L185.119 1.28432Z",
    fill: "#9E7E00"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M186.959 1.3138L186.346 1.2994L186.353 0.0078125L186.966 0.0222575L186.959 1.3138Z",
    fill: "#9E7E00"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M188.799 1.36458L188.186 1.34296L188.207 0.0585938L188.821 0.0730387L188.799 1.36458Z",
    fill: "#9E7E00"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M192.176 1.44393L191.873 1.43671L191.916 0.152344L192.227 0.159566L192.176 1.44393Z",
    fill: "#9E7E00"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M194.773 1.50834L194.463 1.50112L194.528 0.216797L194.831 0.224019L194.773 1.50834Z",
    fill: "#9E7E00"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M197.357 1.69603L197.054 1.67436L197.133 0.382812L197.436 0.411658L197.357 1.69603Z",
    fill: "#9E7E00"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M199.734 0.59102L199.637 1.87891L199.946 1.90238L200.044 0.614499L199.734 0.59102Z",
    fill: "#9E7E00"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M202.522 2.09251L202.219 2.06366L202.334 0.779297L202.644 0.808187L202.522 2.09251Z",
    fill: "#9E7E00"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M208.318 2.7351C206.392 2.50421 204.472 2.19393 202.531 2.09292L202.647 0.808594C204.602 0.90961 206.536 1.22706 208.477 1.45796L208.318 2.7351Z",
    fill: "#9E7E00"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M212.032 3.20369L209.139 2.83574L209.305 1.55859L212.212 1.92659L212.032 3.20369Z",
    fill: "#9E7E00"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M214.016 3.47806C213.698 3.41312 213.374 3.36986 213.049 3.33379L213.236 2.05664C213.561 2.09272 213.886 2.13602 214.211 2.20096L214.016 3.47806Z",
    fill: "#9E7E00"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M215.844 3.80377L215.36 3.71719L215.57 2.44727L216.053 2.53385L215.844 3.80377Z",
    fill: "#9E7E00"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M217.112 4.03365L216.629 3.94707L216.845 2.66992L217.329 2.7565L217.112 4.03365Z",
    fill: "#9E7E00"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M218.119 2.90038L217.892 4.17188L218.375 4.25809L218.602 2.98659L218.119 2.90038Z",
    fill: "#9E7E00"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M219.646 4.48209L219.162 4.39551L219.4 3.13281L219.884 3.21939L219.646 4.48209Z",
    fill: "#9E7E00"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M222.653 5.02311L222.17 4.93653L222.43 3.67383L222.913 3.76041L222.653 5.02311Z",
    fill: "#9E7E00"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M226.34 5.87286L225.864 5.75743L226.146 4.50195L226.622 4.61016L226.34 5.87286Z",
    fill: "#9E7E00"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M232.033 7.20882C230.785 6.8697 229.522 6.61716 228.267 6.31412L228.562 5.05859C229.825 5.36164 231.102 5.6214 232.351 5.96052L232.026 7.20882H232.033Z",
    fill: "#9E7E00"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M236.882 8.5869L234.068 7.786L234.407 6.54492L237.243 7.35305L236.882 8.5869Z",
    fill: "#9E7E00"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M240.095 9.49671L238.312 8.99162L238.688 7.75781L240.477 8.27008L240.095 9.49671Z",
    fill: "#9E7E00"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M242.98 10.4619L242.1 10.1661L242.496 8.93945L243.377 9.23531L242.98 10.4619Z",
    fill: "#9E7E00"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M245.05 11.1617L244.177 10.8659L244.588 9.64648L245.468 9.9423L245.05 11.1617Z",
    fill: "#9E7E00"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M246.515 11.6603L245.931 11.4655L246.356 10.2461L246.941 10.4409L246.515 11.6603Z",
    fill: "#9E7E00"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M248.261 12.2521L247.677 12.0501L248.11 10.8379L248.694 11.0399L248.261 12.2521Z",
    fill: "#9E7E00"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M249.987 12.8949L249.417 12.6712L249.864 11.459L250.434 11.6899L249.987 12.8949Z",
    fill: "#9E7E00"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M251.696 13.5732L251.126 13.3495L251.588 12.1445L252.158 12.3682L251.696 13.5732Z",
    fill: "#9E7E00"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M253.414 14.2437L252.844 14.0201L253.313 12.8223L253.89 13.0459L253.414 14.2437Z",
    fill: "#9E7E00"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M255.124 14.9215L254.554 14.6978L255.037 13.5L255.614 13.7309L255.124 14.9215Z",
    fill: "#9E7E00"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M258.246 16.2136L257.965 16.0837L258.477 14.9004L258.751 15.0303L258.246 16.2136Z",
    fill: "#9E7E00"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M260.607 17.2806L260.333 17.1507L260.852 15.9746L261.134 16.1045L260.607 17.2806Z",
    fill: "#9E7E00"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M262.973 18.3496L262.691 18.2197L263.233 17.0508L263.514 17.1807L262.973 18.3496Z",
    fill: "#9E7E00"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M265.333 19.4165L265.052 19.2867L265.607 18.125L265.889 18.2549L265.333 19.4165Z",
    fill: "#9E7E00"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M267.642 20.5923L267.368 20.4552L267.945 19.3008L268.22 19.4378L267.642 20.5923Z",
    fill: "#9E7E00"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M272.829 23.2492L267.642 20.5939L268.219 19.4395L273.443 22.1164L272.829 23.2492Z",
    fill: "#9E7E00"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M276.091 25.0968L273.565 23.6393L274.179 22.5137L276.726 23.9712L276.091 25.0968Z",
    fill: "#9E7E00"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M277.823 26.0914L276.979 25.6008L277.613 24.4824L278.472 24.9731L277.823 26.0914Z",
    fill: "#9E7E00"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M279.432 27.0166L279.006 26.7713L279.662 25.6602L280.088 25.9127L279.432 27.0166Z",
    fill: "#9E7E00"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M280.55 27.6579L280.124 27.4126L280.788 26.3086L281.214 26.5539L280.55 27.6579Z",
    fill: "#9E7E00"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M281.647 28.3285L281.235 28.0688L281.906 26.9648L282.325 27.2318L281.647 28.3285Z",
    fill: "#9E7E00"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M282.737 29.0278L282.318 28.7608L282.997 27.6641L283.415 27.931L282.737 29.0278Z",
    fill: "#9E7E00"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M285.555 29.229L284.858 30.3164L285.271 30.5812L285.968 29.4938L285.555 29.229Z",
    fill: "#9E7E00"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M288.495 32.7157L288.076 32.4487L288.798 31.3809L289.216 31.6478L288.495 32.7157Z",
    fill: "#9E7E00"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M293.257 36.1074L290.104 33.8634L290.84 32.8027L294.014 35.0612L293.257 36.1074Z",
    fill: "#9E7E00"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M297.313 39.1017C296.541 38.5028 295.79 37.8751 294.989 37.3339L295.754 36.2949C296.569 36.8505 297.32 37.4782 298.099 38.0771L297.313 39.1017Z",
    fill: "#9E7E00"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M299.938 41.1646L298.48 40.0246L299.274 39L300.739 40.1545L299.938 41.1646Z",
    fill: "#9E7E00"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M302.325 43.0417L301.597 42.4717L302.412 41.4688L303.141 42.046L302.325 43.0417Z",
    fill: "#9E7E00"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M304.001 44.4632L303.301 43.8571L304.123 42.8613L304.83 43.4747L304.001 44.4632Z",
    fill: "#9E7E00"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M305.163 45.466L304.701 45.0692L305.538 44.0879L306 44.492L305.163 45.466Z",
    fill: "#9E7E00"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M306.946 45.3383L306.101 46.3145L306.564 46.7161L307.41 45.74L306.946 45.3383Z",
    fill: "#9E7E00"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M307.946 47.8827L307.484 47.4786L308.336 46.5117L308.805 46.9158L307.946 47.8827Z",
    fill: "#9E7E00"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M309.34 49.087L308.878 48.6829L309.744 47.7305L310.206 48.1345L309.34 49.087Z",
    fill: "#9E7E00"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M310.675 50.3573L310.234 49.9315L311.108 48.9863L311.555 49.4121L310.675 50.3573Z",
    fill: "#9E7E00"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M312.01 51.6274L311.569 51.2017L312.45 50.2637L312.897 50.6894L312.01 51.6274Z",
    fill: "#9E7E00"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M314.456 53.9571L314.232 53.7478L315.134 52.8242L315.358 53.0407L314.456 53.9571Z",
    fill: "#9E7E00"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M316.311 55.7681L316.095 55.5517L317.011 54.6426L317.22 54.8662L316.311 55.7681Z",
    fill: "#9E7E00"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M318.092 57.6536L317.883 57.4299L318.814 56.5352L319.023 56.7517L318.092 57.6536Z",
    fill: "#9E7E00"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M319.881 59.5292L319.672 59.3055L320.61 58.418L320.826 58.6417L319.881 59.5292Z",
    fill: "#9E7E00"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M321.671 61.3981L321.462 61.1816L322.414 60.3086L322.624 60.5323L321.671 61.3981Z",
    fill: "#9E7E00"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M325.503 65.7971C324.226 64.3324 322.97 62.8532 321.679 61.4029L322.631 60.5371C323.937 61.9946 325.2 63.4882 326.484 64.9602L325.503 65.7971Z",
    fill: "#9E7E00"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M327.941 68.64C327.335 67.8824 326.679 67.168 326.051 66.4248L327.032 65.5879C327.667 66.3311 328.331 67.0526 328.937 67.8174L327.941 68.6328V68.64Z",
    fill: "#9E7E00"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M329.174 70.2129L328.568 69.4409L329.571 68.6328L330.177 69.4048L329.174 70.2129Z",
    fill: "#9E7E00"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M331.032 70.4536L330.017 71.252L330.32 71.6377L331.335 70.8393L331.032 70.4536Z",
    fill: "#9E7E00"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M331.117 72.6872L330.813 72.2976L331.831 71.5039L332.134 71.8936L331.117 72.6872Z",
    fill: "#9E7E00"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M331.916 73.6982L331.613 73.3158L332.631 72.5293L332.941 72.9116L331.916 73.6982Z",
    fill: "#9E7E00"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M332.711 74.7066L332.408 74.3242L333.433 73.5449L333.743 73.9346L332.711 74.7066Z",
    fill: "#9E7E00"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M334.507 77.1832L334.226 76.7791L335.265 76.0215L335.553 76.4183L334.507 77.1832Z",
    fill: "#9E7E00"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M336.7 80.2631L336.419 79.859L337.472 79.123L337.761 79.5272L336.7 80.2631Z",
    fill: "#9E7E00"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M339.968 85.113L338.922 83.4823C338.575 82.9412 338.229 82.3928 337.847 81.8733L338.915 81.1445C339.304 81.664 339.651 82.2196 339.997 82.7608L341.05 84.3987L339.968 85.1058V85.113Z",
    fill: "#9E7E00"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M342.69 89.3543L341.109 86.8938L342.199 86.2012L343.786 88.6832L342.69 89.3543Z",
    fill: "#9E7E00"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M344.385 92.2338L343.461 90.6248L344.565 89.9609L345.496 91.5772L344.385 92.2338Z",
    fill: "#9E7E00"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M345.899 94.8669L345.438 94.066L346.556 93.4238L347.018 94.232L345.899 94.8669Z",
    fill: "#9E7E00"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M346.99 96.7646L346.528 95.9637L347.654 95.3359L348.123 96.1441L346.99 96.7646Z",
    fill: "#9E7E00"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M347.74 98.1154C347.646 97.935 347.559 97.7474 347.451 97.5742L348.584 96.9609C348.692 97.1341 348.772 97.3217 348.873 97.5093L347.74 98.1226V98.1154Z",
    fill: "#9E7E00"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M348.577 99.7528L348.303 99.2116L349.436 98.6055L349.717 99.1538L348.577 99.7528Z",
    fill: "#9E7E00"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M349.422 101.391L349.141 100.85L350.288 100.258L350.569 100.806L349.422 101.391Z",
    fill: "#9E7E00"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M350.258 103.036L349.977 102.487L351.131 101.91L351.412 102.459L350.258 103.036Z",
    fill: "#9E7E00"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M351.095 104.675L350.821 104.134L351.976 103.557L352.257 104.105L351.095 104.675Z",
    fill: "#9E7E00"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M351.904 106.326L351.651 105.77L352.813 105.215L353.073 105.778L351.904 106.326Z",
    fill: "#9E7E00"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M353.297 109.407L353.174 109.133L354.343 108.592L354.473 108.873L353.297 109.407Z",
    fill: "#9E7E00"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M354.364 111.774L354.241 111.492L355.417 110.973L355.547 111.254L354.364 111.774Z",
    fill: "#9E7E00"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M355.418 114.14L355.303 113.851L356.493 113.354L356.609 113.635L355.418 114.14Z",
    fill: "#9E7E00"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M356.37 116.549L356.255 116.268L357.453 115.777L357.561 116.066L356.37 116.549Z",
    fill: "#9E7E00"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M357.316 118.959L357.208 118.678L358.406 118.209L358.521 118.498L357.316 118.959Z",
    fill: "#9E7E00"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M359.342 124.423C359.017 123.507 358.743 122.576 358.382 121.674L357.314 118.961L358.519 118.492L359.595 121.22C359.955 122.129 360.237 123.067 360.561 123.99L359.342 124.416V124.423Z",
    fill: "#9E7E00"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M360.547 127.973L359.609 125.217L360.829 124.791L361.774 127.569L360.547 127.973Z",
    fill: "#9E7E00"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M361.189 129.871L360.871 128.94L362.098 128.543L362.415 129.481L361.189 129.871Z",
    fill: "#9E7E00"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M361.738 131.638L361.601 131.169L362.834 130.787L362.972 131.263L361.738 131.638Z",
    fill: "#9E7E00"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M362.091 132.879L361.954 132.41L363.188 132.035L363.325 132.511L362.091 132.879Z",
    fill: "#9E7E00"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M362.437 134.12L362.308 133.651L363.541 133.283L363.679 133.759L362.437 134.12Z",
    fill: "#9E7E00"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M362.792 135.361L362.662 134.885L363.896 134.531L364.033 135.007L362.792 135.361Z",
    fill: "#9E7E00"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M363.629 138.299L363.492 137.83L364.74 137.498L364.877 137.967L363.629 138.299Z",
    fill: "#9E7E00"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M364.538 141.972L364.43 141.496L365.678 141.186L365.793 141.669L364.538 141.972Z",
    fill: "#9E7E00"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M365.851 147.672L364.985 143.898L366.241 143.609L367.114 147.405L365.851 147.672Z",
    fill: "#9E7E00"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M366.775 152.628L366.263 149.749L367.525 149.496L368.045 152.397L366.775 152.628Z",
    fill: "#9E7E00"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M367.359 155.911L367.034 154.086L368.304 153.869L368.636 155.709L367.359 155.911Z",
    fill: "#9E7E00"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M367.821 158.912L367.705 157.996L368.982 157.801L369.098 158.732L367.821 158.912Z",
    fill: "#9E7E00"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M368.102 161.086L367.979 160.169L369.257 159.996L369.379 160.92L368.102 161.086Z",
    fill: "#9E7E00"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M369.537 161.776L368.256 161.939L368.333 162.548L369.615 162.385L369.537 161.776Z",
    fill: "#9E7E00"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M368.528 164.447L368.448 163.834L369.725 163.689L369.805 164.296L368.528 164.447Z",
    fill: "#9E7E00"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M368.758 166.273L368.679 165.666L369.963 165.529L370.042 166.135L368.758 166.273Z",
    fill: "#9E7E00"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M368.918 168.105L368.875 167.499L370.159 167.369L370.203 167.99L368.918 168.105Z",
    fill: "#9E7E00"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M369.054 169.946L369.011 169.333L370.295 169.225L370.346 169.838L369.054 169.946Z",
    fill: "#9E7E00"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2 171.777L369.149 171.171L370.441 171.07L370.484 171.684L369.2 171.777Z",
    fill: "#9E7E00"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M369.45 175.147L369.429 174.844L370.72 174.771L370.742 175.082L369.45 175.147Z",
    fill: "#9E7E00"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M369.567 177.738L369.56 177.435L370.844 177.377L370.851 177.687L369.567 177.738Z",
    fill: "#9E7E00"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M369.631 180.327L369.624 180.024L370.908 179.988L370.916 180.291L369.631 180.327Z",
    fill: "#9E7E00"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M369.698 182.926L369.69 182.615L370.975 182.594L370.982 182.904L369.698 182.926Z",
    fill: "#9E7E00"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M369.761 185.515L369.754 185.205H371.038L371.053 185.515H369.761Z",
    fill: "#9E7E00"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.5,
    d: "M343.772 119.604C335.149 98.7733 322.371 79.6957 306.432 63.7568C290.493 47.8179 271.415 35.0394 250.584 26.4169C229.768 17.7656 207.234 13.3426 184.7 13.3281C162.166 13.3353 139.633 17.7584 118.816 26.4169C97.9852 35.0394 78.9076 47.8179 62.9687 63.7568C47.0298 79.6884 34.2513 98.7733 25.6288 119.604C16.9775 140.421 12.5473 162.954 12.54 185.488C12.54 208.022 16.9703 230.556 25.6288 251.372C34.2513 272.203 47.0298 291.281 62.9687 307.22C78.9076 323.159 97.9852 335.937 118.816 344.56C139.633 353.211 162.166 357.634 184.7 357.648C207.234 357.641 229.768 353.218 250.584 344.56C271.415 335.937 290.493 323.159 306.432 307.22C322.371 291.288 335.149 272.203 343.772 251.372C352.423 230.556 356.846 208.022 356.86 185.488C356.853 162.954 352.43 140.421 343.772 119.604ZM341.39 250.391C332.898 270.905 320.307 289.701 304.613 305.394C288.913 321.095 270.116 333.686 249.61 342.171C229.104 350.693 206.916 355.058 184.707 355.065C162.506 355.058 140.311 350.693 119.805 342.171C99.2912 333.686 80.495 321.095 64.7942 305.394C49.0934 289.694 36.5025 270.897 28.0171 250.391C19.4957 229.885 15.1304 207.697 15.1232 185.488C15.1304 163.286 19.4957 141.092 28.0171 120.586C36.5025 100.072 49.0934 81.2758 64.7942 65.5751C80.495 49.8743 99.2912 37.2834 119.805 28.798C140.311 20.2766 162.498 15.9113 184.707 15.904C206.909 15.9113 229.104 20.2766 249.61 28.798C270.124 37.2834 288.92 49.8743 304.613 65.5751C320.314 81.2758 332.905 100.072 341.39 120.586C349.912 141.092 354.277 163.279 354.284 185.488C354.277 207.69 349.912 229.885 341.39 250.391Z",
    fill: "url(#paint0_linear_2520_4462)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M305.35 315.395C278.812 340.267 244.387 356.487 208.151 361.235L206.65 348.406C240.18 343.961 272.022 328.931 296.562 305.929C321.52 282.745 338.859 252.101 345.576 219.387L358.261 221.826C351.031 257.217 332.307 290.358 305.343 315.388L305.35 315.395Z",
    fill: "url(#paint1_linear_2520_4462)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M358.268 221.825C351.038 257.217 332.314 290.357 305.35 315.387C278.812 340.259 244.387 356.479 208.151 361.227L206.65 348.398C240.18 343.953 272.022 328.924 296.562 305.921C321.52 282.738 338.859 252.094 345.576 219.379L358.261 221.818L358.268 221.825Z",
    fill: "url(#paint2_linear_2520_4462)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M361.985 182.269L349.069 182.305C348.672 160.861 343.975 139.301 335.417 119.783C326.889 100.258 314.283 82.1403 298.871 67.2405L307.696 57.8027C324.385 73.9004 338.029 93.483 347.258 114.617C356.522 135.737 361.588 159.071 361.985 182.262V182.269Z",
    fill: "url(#paint3_linear_2520_4462)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M96.9306 324.529L90.2059 335.554C60.7669 316.981 36.8766 289.433 22.756 257.706C8.22413 225.381 3.84437 188.171 10.4104 152.91C16.8466 117.871 34.3728 84.7527 59.7784 59.6502C84.5129 35.0384 116.744 17.9884 150.787 11.4512L153.052 24.1648C121.571 30.2546 91.7716 46.0492 68.877 68.8138C45.3259 92.0908 29.0695 122.8 23.1024 155.276C17.0053 187.991 21.0676 222.502 34.546 252.446C47.606 281.799 69.6996 307.305 96.9234 324.529H96.9306Z",
    fill: "url(#paint4_linear_2520_4462)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2520_4462",
    x1: 2.32299,
    y1: 32.5356,
    x2: 342.718,
    y2: 318.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A28400",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9A7D00",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D7200",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#796200",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#604E00",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#413500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1D1800",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2520_4462",
    x1: -9.20636,
    y1: 46.2885,
    x2: 331.189,
    y2: 331.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A28400",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9A7D00",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D7200",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#796200",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#604E00",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#413500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1D1800",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2520_4462",
    x1: -9.20638,
    y1: 46.2879,
    x2: 331.189,
    y2: 331.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#A58600",
    stopOpacity: 0.63
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#A58600",
    stopOpacity: 0.29
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#A58600",
    stopOpacity: 0.08
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A58600",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2520_4462",
    x1: 93.8661,
    y1: -76.6207,
    x2: 434.261,
    y2: 208.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A28400",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9A7D00",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D7200",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#796200",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#604E00",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#413500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1D1800",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2520_4462",
    x1: -18.7976,
    y1: 57.7165,
    x2: 321.597,
    y2: 343.195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A58600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#A28400",
    stopOpacity: 0.99
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#9A7D00",
    stopOpacity: 0.94
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#8D7200",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#796200",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#604E00",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#413500",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#1D1800",
    stopOpacity: 0.18
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnticlockwise);
export default __webpack_public_path__ + "static/media/anticlockwise.dd16c3458b4da33e853a328a44e148a7.svg";
export { ForwardRef as ReactComponent };